export const steps = Object.freeze({
  introduction: 'introduction',
  permissions: 'permissions',
  roles: 'roles',
  organizationInfo: 'organization-info',
});

export const totalStepCount = Object.keys(steps).length;
